import React from 'react'
import Vendors from '../components/Vendors'
function AllVendors() {
  return (
    <Vendors/>
  )
}

export default AllVendors